export default class publicOrderApi {
    getAppOrderDetail(customerNumber) {
        return this.GET(`order/app/order/getOneByCustomerNumber/${customerNumber}`);
    }
}
